<div class="modal-header">
  <h4 class="modal-title">{{ headerText }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{ text || "Are you sure you want to do this?" }}</p>
</div>
<div class="modal-footer" *ngIf="canCancel">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close(false)">{{ isEnglishLocale() ? "No" : "Não"}}</button>
  <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">{{ isEnglishLocale() ? "Yes" : "Sim"}}</button>
</div>
<div class="modal-footer" *ngIf="!canCancel">
  <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">Ok</button>
</div>
